import React, { useContext } from 'react';
import { useRouteMatch } from 'react-router-dom';
import { DeliveryProvider, AuthContext } from '@CONTEXTS';
import { AppRouter } from '@MASTER';
import { useAuthority } from '@HOOKS';
import PreOrder from './pre-order';
import Operation from './operation';

const Deliveries = () => {
  let { path } = useRouteMatch();
  const {
    info: { operationDisabled },
  } = useContext(AuthContext);
  return (
    <div className="app-definitions">
      {useAuthority('DELIVERY_LIST_PRE_ORDER') && (
        <AppRouter path={`${path}/pre-order`} title="Paketlenecek Gönderilerim">
          <DeliveryProvider>
            <PreOrder />
          </DeliveryProvider>
        </AppRouter>
      )}
      {useAuthority('DELIVERY_LIST_OPERATION') && !operationDisabled && (
        <AppRouter
          path={`${path}/operation`}
          component={Operation}
          title="Operasyondaki Gönderilerim"
        />
      )}
    </div>
  );
};

export default Deliveries;
